/*
 * @Author: 王枫叶
 * @Date: 2020-10-13 17:37:19
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-10-21 14:27:58
 */
import WebActivity from "../views/activityManagement/webActivity";
import RedemptionCode from "../views/activityManagement/redemptionCode";
import RedemptionLog from "../views/activityManagement/redemptionLog";
// 活动-奖品列表
import RedemptionPrize from "../views/activityManagement/redemptionPrize";
import TenderActivity from "../views/activityManagement/tenderActivity";
import BuyPage from "../views/activityManagement/buyPage";
import PrizePoolList from "../views/activityManagement/prizepoolList";
import ConfigurationList from "../views/activityManagement/configurationList";
import PointsPrizesList from "../views/activityManagement/pointsPrizesList";
import DailyTaskList from "../views/activityManagement/dailyTaskList";
import OneTaskList from "../views/activityManagement/oneTaskList";
// import ListOfPrizes from "../views/activityManagement/listOfPrizes";
// import LotteryList from "../views/activityManagement/lotteryList";
import GoldeneggLog from '../views/activityManagement/goldeneggLog'
import Main from "../views/main";

const ActivityRouter = {
  path: "/activity-list",
  component: Main,
  title: "活动管理",
  icon: "el-icon-s-promotion",
  meta: {
    keepAlive: true
  },
  children: [{
      path: "/web-activity",
      component: WebActivity,
      name: "webActivity",
      title: "活动列表",
      meta: {
        title: "活动列表",
        keepAlive: true
      },
    },
    {
      path: "/redemption-code",
      component: RedemptionCode,
      name: "redemptionCode",
      title: "兑换码列表",
      meta: {
        title: "兑换码列表",
        keepAlive: true
      },
    },
    {
      path: "/redemption-log",
      component: RedemptionLog,
      name: "redemptionLog",
      title: "兑换码兑换日志",
      meta: {
        title: "兑换码兑换日志",
        keepAlive: true
      },
    },
    // 活动-奖品列表
    {
      path: "/redemption-prize",
      component: RedemptionPrize,
      name: "redemptionPrize",
      title: "奖品列表",
      meta: {
        title: "奖品列表",
        keepAlive: true
      },
    },
    {
      path: "/prize-pool-list",
      component: PrizePoolList,
      name: "prizePoolList",
      title: "奖池列表",
      meta: {
        title: "奖池列表",
        keepAlive: true
      },
    },
    // {
    //   path: '/list-prizes',
    //   component: ListOfPrizes,
    //   name: 'listOfPrizes',
    //   title: '任务福利列表',
    //   meta: {
    //     title: '任务福利列表',
    //     keepAlive: true
    //   }
    // },
    {
      path: '/configuration-list',
      component: ConfigurationList,
      name: 'configurationList',
      title: '任务列表',
      meta: {
        title: '任务列表',
        keepAlive: true
      }
    },
    {
      path: "/one-task-list",
      component: OneTaskList,
      name: "oneTaskList",
      title: "一次性任务列表",
      meta: {
        title: "一次性任务列表",
        keepAlive: true,
      },
    },
    {
      path: "/daily-task-list",
      component: DailyTaskList,
      name: "dailyTaskList",
      title: "日常任务列表",
      meta: {
        title: "日常任务列表",
        keepAlive: true,
      },
    },
    {
      path: '/points-prizes=list',
      component: PointsPrizesList,
      name: 'pointsPrizesList',
      title: '积分奖品列表',
      meta: {
        title: '积分奖品列表',
        keepAlive: true
      }
    },
    {
      path: "/tender-activity",
      component: TenderActivity,
      name: "tenderActivity",
      title: "嫩模获奖记录",
      meta: {
        title: "嫩模获奖记录",
        keepAlive: true
      },
    },
    {
      path: "/buy-page",
      component: BuyPage,
      name: "buyPage",
      title: "嫩模购买列表",
      meta: {
        title: "嫩模购买列表",
        keepAlive: true
      },
    },
    // {
    //   path: "/lottery-list",
    //   component: LotteryList,
    //   name: "lotteryList",
    //   title: "摇奖号列表",
    //   meta: { title: "摇奖号列表", keepAlive: true },
    // },
    {
      path: '/goldeneggLog',
      component: GoldeneggLog,
      name: 'goldeneggLog',
      title: '活动记录',
      meta: {
        title: "活动记录",
        keepAlive: true
      },
    }
  ],
};
export default ActivityRouter;